import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  decreaseQty,
  increaseQty,
  removeItem,
} from "../../../slices/cart/publicOrderingCartSlice";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import { Col, Row } from "reactstrap";

// ============= CART ITEMS SECTION COMPONENT =============
const TouchBasedCartItemsList = ({ cart }) => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState({});

  const toggle = (uid) => setExpanded((s) => ({ ...s, [uid]: !s[uid] }));

  if (!cart || cart.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "40px 20px", color: "#999" }}>
        <i
          className="bx bx-cart"
          style={{ fontSize: "48px", display: "block", marginBottom: "12px" }}
        />
        <div>Your cart is empty</div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: "16px",
      }}
    >
      {cart.map((item) => {
        const quantity = item.qty || item.quantity || 0;
        const unitPrice = item.basePrice || item.price || 0;
        const addonsTotal = (item.addons || []).reduce(
          (sum, a) => sum + (a.price || 0),
          0,
        );
        const itemTotal = (unitPrice + addonsTotal) * quantity;

        return (
          <div
            key={item.uid || item.id}
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              border: "1px solid #f0f0f0",
              overflow: "hidden",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            {/* Main Item Card */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px",
              }}
            >
              {/* Item Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    color: "#2c3e50",
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "4px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.name}
                </div>

                <div
                  style={{
                    color: "#888",
                    fontSize: "12px",
                    marginBottom: "4px",
                  }}
                >
                  Rs. <NumberWithCommas number={unitPrice} /> × {quantity} ={" "}
                  <span style={{ fontWeight: "600", color: "#ff7900" }}>
                    Rs. <NumberWithCommas number={itemTotal} />
                  </span>
                </div>

                {/* Quick summary of addons */}
                {(item.addons || []).length > 0 && (
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#666",
                      marginTop: "4px",
                    }}
                  >
                    + {(item.addons || []).map((a) => a.name).join(", ")}
                  </div>
                )}

                {/* Quick note preview */}
                {item.note && (
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#999",
                      fontStyle: "italic",
                      marginTop: "4px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Note: {item.note}
                  </div>
                )}
              </div>

              {/* Quantity Controls */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  flexShrink: 0,
                }}
              >
                <button
                  onClick={() => dispatch(decreaseQty(item.uid))}
                  disabled={quantity <= 1}
                  style={{
                    width: "28px",
                    height: "28px",
                    border: "1px solid",
                    borderColor: quantity <= 1 ? "#ccc" : "#ff7900",
                    borderRadius: "6px",
                    background: quantity <= 1 ? "#f2f2f2" : "white",
                    color: quantity <= 1 ? "#999" : "#ff7900",
                    cursor: quantity <= 1 ? "not-allowed" : "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    if (quantity <= 1) return;
                    e.currentTarget.style.backgroundColor = "#ff7900";
                    e.currentTarget.style.color = "white";
                  }}
                  onMouseOut={(e) => {
                    if (quantity <= 1) return;
                    e.currentTarget.style.backgroundColor = "white";
                    e.currentTarget.style.color = "#ff7900";
                  }}
                >
                  −
                </button>

                <div
                  style={{
                    minWidth: "32px",
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#2c3e50",
                  }}
                >
                  {quantity}
                </div>

                <button
                  onClick={() => dispatch(increaseQty(item.uid))}
                  style={{
                    width: "28px",
                    height: "28px",
                    border: "1px solid #ff7900",
                    borderRadius: "6px",
                    background: "#ff7900",
                    color: "white",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#e56a00";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#ff7900";
                  }}
                >
                  +
                </button>

                <button
                  onClick={() => dispatch(removeItem(item.uid))}
                  title="Remove item"
                  style={{
                    width: "28px",
                    height: "28px",
                    border: "none",
                    background: "transparent",
                    color: "#dc3545",
                    cursor: "pointer",
                    fontSize: "20px",
                    fontWeight: "bold",
                    marginLeft: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = "#a71d2a";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = "#dc3545";
                  }}
                >
                  ×
                </button>
              </div>
            </div>

            {/* Expanded details */}
            {expanded[item.uid] && (
              <div
                style={{
                  background: "#f9f9f9",
                  borderTop: "1px solid #f0f0f0",
                  padding: "12px",
                  fontSize: "12px",
                }}
              >
                {(item.addons || []).length > 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginBottom: "6px",
                      }}
                    >
                      Addons
                    </div>
                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: "20px",
                        color: "#666",
                      }}
                    >
                      {item.addons.map((a, idx) => (
                        <li key={idx} style={{ marginBottom: "4px" }}>
                          {a.name} — Rs. {a.price}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {item.extras && item.extras.length > 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginBottom: "6px",
                      }}
                    >
                      Extras
                    </div>
                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: "20px",
                        color: "#666",
                      }}
                    >
                      {item.extras.map((e, idx) => (
                        <li key={idx} style={{ marginBottom: "4px" }}>
                          {e.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {item.attributes && Object.keys(item.attributes).length > 0 && (
                  <div style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginBottom: "6px",
                      }}
                    >
                      Attributes
                    </div>
                    <div style={{ color: "#666" }}>
                      {Object.entries(item.attributes).map(
                        ([key, value], idx) => (
                          <div key={idx} style={{ marginBottom: "4px" }}>
                            {key}: {value}
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                )}

                {/* {item.note && (
                  <div>
                    <div
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginBottom: "6px",
                      }}
                    >
                      Notes
                    </div>
                    <div style={{ color: "#666", fontStyle: "italic" }}>
                      {item.note}
                    </div>
                  </div>
                )} */}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TouchBasedCartItemsList;
